import { g as getLocale, t as trackMessageCall } from "./runtime.js";
const en_title = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Shrtn - your own link shortener`;
  }
);
const de_title = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Shrtn - dein eigener Link-Kürzer`;
  }
);
const sp_title = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Shrtn - tu propio acortador de enlaces`;
  }
);
const title = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("title", locale);
  if (locale === "en") return en_title();
  if (locale === "de") return de_title();
  return sp_title();
};
const en_meta_description = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Shrtn is your own customizable link shortener. Easily shorten, manage, and track your links with our open-source solution.`;
  }
);
const de_meta_description = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Shrtn ist dein eigener anpassbarer Link-Kürzer. Kürze, verwalte und verfolge deine Links einfach mit unserer Open-Source-Lösung.`;
  }
);
const sp_meta_description = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Shrtn es tu propio acortador de enlaces personalizable. Acorta, gestiona y rastrea tus enlaces fácilmente con nuestra solución de código abierto.`;
  }
);
const meta_description = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("meta_description", locale);
  if (locale === "en") return en_meta_description();
  if (locale === "de") return de_meta_description();
  return sp_meta_description();
};
const en_meta_keywords = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `link shortener, URL shortener, open-source, customizable, link management`;
  }
);
const de_meta_keywords = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Link-Kürzer, URL-Kürzer, Open-Source, anpassbar, Link-Verwaltung`;
  }
);
const sp_meta_keywords = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Acortador de enlaces, Acortador de URL, Código abierto, Personalizable, Gestión de enlaces`;
  }
);
const meta_keywords = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("meta_keywords", locale);
  if (locale === "en") return en_meta_keywords();
  if (locale === "de") return de_meta_keywords();
  return sp_meta_keywords();
};
const en_about_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `About`;
  }
);
const de_about_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Über uns`;
  }
);
const sp_about_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Acerca de`;
  }
);
const about_link = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("about_link", locale);
  if (locale === "en") return en_about_link();
  if (locale === "de") return de_about_link();
  return sp_about_link();
};
const en_setup_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Setup`;
  }
);
const de_setup_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Setup`;
  }
);
const sp_setup_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Configuración`;
  }
);
const setup_link = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("setup_link", locale);
  if (locale === "en") return en_setup_link();
  if (locale === "de") return de_setup_link();
  return sp_setup_link();
};
export {
  meta_keywords as a,
  about_link as b,
  meta_description as m,
  setup_link as s,
  title as t
};
